import { TwentyFourHourContent } from './PSPContents/24-Hour';
import { ClimateControlContent } from './PSPContents/ClimateControlContent';
import { DriveUpContent } from './PSPContents/DriveUpContent';
import { PortableStorageContent } from './PSPContents/PortableStorageContent';
import { ElectricityContent } from './PSPContents/ElectricityContent';
import { WineContent } from './PSPContents/WineContent';
import { CollegeContent } from './PSPContents/CollegeContent';
import { BusinessContent } from './PSPContents/BusinessContent';
import { MilitaryContent } from './PSPContents/MilitaryContent';
import { ATVContent } from './PSPContents/ATVContent';
import { BicycleContent } from './PSPContents/BicycleContent';
import { BoatContent } from './PSPContents/BoatContent';
import { CarContent } from './PSPContents/CarContent';
import { DirtBikeContent } from './PSPContents/DirtBikeContent';
import { GolfCartContent } from './PSPContents/GolfCartContent';
import { JetskiContent } from './PSPContents/JetskiContent';
import { KayakContent } from './PSPContents/KayakContent';
import { MotorcycleStorageContent } from './PSPContents/MotorcycleStorageContent';
import { SelfStorageContent } from './PSPContents/SelfStorageContent';
import { RVContent } from './PSPContents/RVContent';
import { TruckContent } from './PSPContents/TruckContent';
import { VehicleContent } from './PSPContents/VehicleContent';
import { TenByThirtyContent } from './SGPContents/10x30Content';
import { content5x5 } from './SGPContents/5x5Content';
import { LockerContent } from './SGPContents/LockerContent';
import { content5x10 } from './SGPContents/5x10Content';
import { TenByTenContent } from './SGPContents/10x10Content';
import { TenByFifteenContent } from './SGPContents/10x15Content';
import { TenByTwentyContent } from './SGPContents/10x20Content';
import { content5x15 } from './SGPContents/5x15Content';
import { MiniContent } from './SGPContents/MiniStorage.js';
import { TenByTwentyFiveContent } from './SGPContents/10x25Content';
import { pageTypes } from 'config/pageTypes';
import { getMetadata } from 'pages/PSPPage/utils/getMetadata';

const PSPContentMap = {
	'24-hour': TwentyFourHourContent,
	'climate-controlled': ClimateControlContent,
	'drive-up': DriveUpContent,
	portable: PortableStorageContent,
	electricity: ElectricityContent,
	wine: WineContent,
	college: CollegeContent,
	business: BusinessContent,
	military: MilitaryContent,
	atv: ATVContent,
	bicycle: BicycleContent,
	boat: BoatContent,
	car: CarContent,
	'dirt-bike': DirtBikeContent,
	'golf-cart': GolfCartContent,
	'jet-ski': JetskiContent,
	kayak: KayakContent,
	motorcycle: MotorcycleStorageContent,
	self: SelfStorageContent,
	rv: RVContent,
	truck: TruckContent,
	vehicle: VehicleContent,
	'5x5': content5x5,
	'storage-lockers': LockerContent,
	'5x15': content5x15,
	'10x30': TenByThirtyContent,
	'5x10': content5x10,
	'10x10': TenByTenContent,
	'10x15': TenByFifteenContent,
	'10x20': TenByTwentyContent,
	'mini-storage': MiniContent,
	'10x25': TenByTwentyFiveContent,
};

export function getPSPContent(keyword) {
	if (!keyword) {
		return null;
	}

	const normalizedKeyword = keyword.toLowerCase();
	const content =
		PSPContentMap[normalizedKeyword] || PSPContentMap['self'] || null;
	if (content && content.pageType !== pageTypes.SGP) {
		content.pageType = pageTypes.PSP;
	}
	if (content && content.pageType === pageTypes.SGP) {
		const metaData = getMetadata(normalizedKeyword);
		content.description = metaData.description;
	}
	return content;
}

export function hasPSPContentSSR(keyword) {
	return (
		keyword && Object.prototype.hasOwnProperty.call(PSPContentMap, keyword)
	);
}

export default PSPContentMap;
